// export const POS_LAYOUTS = {
//   MODERN: "modern",
//   CLASSICAL: "classical",
//   MODERN_V2: "modernV2",
// };

// export const getActivePOSLayout = ({ user }) => {
//   const permissions = user?.permissions || {};

//   if (permissions?.isClassicalPOSLayout === true) {
//     return POS_LAYOUTS.CLASSICAL;
//   }

//   if (permissions?.isModernV2POSLayout === true) {
//     return POS_LAYOUTS.MODERN_V2;
//   }

//   return POS_LAYOUTS.CLASSICAL;
// };

export const POS_LAYOUTS = {
  MODERN: "modern",
  MODERNV2: "modernv2",
  CLASSICAL: "classical",
};

export const POS_LAYOUT_VALUES = Object.values(POS_LAYOUTS);

export const getActivePOSLayout = ({ user }) => {
  const posLayout = user?.posLayout;

  if (POS_LAYOUT_VALUES.includes(posLayout)) {
    return posLayout;
  }

  return POS_LAYOUTS.MODERN;
};

export const isDirectAddOrderLayout = (user) => [POS_LAYOUTS.CLASSICAL, POS_LAYOUTS.MODERNV2].includes(user?.posLayout);
export const POS_GRID_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const POS_GRID_SIZE_VALUES = Object.values(POS_GRID_SIZES);

// Items per row at md/lg; xl shows one extra column.
const POS_GRID_COLUMNS = {
  [POS_GRID_SIZES.SMALL]: 7,
  [POS_GRID_SIZES.MEDIUM]: 6,
  [POS_GRID_SIZES.LARGE]: 5,
};

export const getActivePOSGridSize = ({ user }) => {
  const posGridSize = user?.posGridSize;

  if (POS_GRID_SIZE_VALUES.includes(posGridSize)) {
    return posGridSize;
  }

  return POS_GRID_SIZES.MEDIUM;
};

export const getPOSGridTemplateColumns = (posGridSize) => {
  const columns = POS_GRID_COLUMNS[posGridSize] ?? POS_GRID_COLUMNS[POS_GRID_SIZES.MEDIUM];

  return {
    xs: "repeat(3, 1fr)",
    sm: "repeat(5, 1fr)",
    md: `repeat(${columns}, 1fr)`,
    lg: `repeat(${columns}, 1fr)`,
    xl: `repeat(${columns + 1}, 1fr)`,
  };
};
